import React from 'react'
import {Body1, Body1PointerLink, ConfirmedText, Subhead3} from "../../../components/Font";
import {AddInfo, AddInfoContent, UserDataContent,} from "../../../components/ui/Content";
import {useAppSelector} from "../../../app/hooks";
import {useTheme} from 'styled-components';

interface IIdentityCardInfoProps {
    goToEditIdentityCard: () => void
    openModalInfo: () => void
}

export const IdentityCardInfo = ({goToEditIdentityCard, openModalInfo}: IIdentityCardInfoProps) => {
    const {passport, foreign_passport, socialNumber} = useAppSelector(state => state.account)

    const Theme = useTheme()
    return (
        <AddInfo
            height={!foreign_passport && !passport && !socialNumber ? '110px' : '160px'}
            background={(passport || foreign_passport) ? Theme.color.primaryBackground : ''}
            cursor={(passport?.is_verified || foreign_passport?.is_verified) ? 'pointer' : 'default'}
            onClick={() => {
                if (passport?.is_verified || foreign_passport?.is_verified) {
                    openModalInfo()
                }
            }}
        >
            <Subhead3>
                Удостоверение личности
            </Subhead3>

            {(!foreign_passport && !passport) ?
                <Body1PointerLink onClick={goToEditIdentityCard}>
                    Добавить
                </Body1PointerLink> :
                <>
                    {!foreign_passport?.is_verified && !passport?.is_verified &&
                        <UserDataContent>
                            {passport &&
                                <Body1 className={'series'}> {` ${`${passport.identityCardType?.name},` || ''} 
                    ${passport.series || ''}  
                    ${passport?.number || ''} `}
                                </Body1>}
                            {foreign_passport &&
                                <Body1 className={'series'}> {` ${`${foreign_passport.identityCardType?.name},` || ''} 
                    ${foreign_passport?.number || ''} `}
                                </Body1>}
                            <Body1PointerLink
                                onClick={goToEditIdentityCard}>
                                Изменить
                            </Body1PointerLink>
                        </UserDataContent>
                    }
                </>}
            {(passport?.is_verified || foreign_passport?.is_verified) &&
                <AddInfoContent>
                    {passport &&
                        <Body1> {` ${`${passport.identityCardType?.name},` || ''} 
                    ${passport.series || ''}  
                    ${passport?.number || ''} `}
                        </Body1>}

                    {foreign_passport &&
                        <Body1> {` ${`${foreign_passport.identityCardType?.name},` || ''} 
                    ${foreign_passport?.number || ''} `}
                        </Body1>}

                    {((passport?.is_verified && passport.isOutdated) || (foreign_passport?.is_verified && foreign_passport.isOutdated)) &&
                        <Body1 color={Theme.color.danger}>
                            Истек {passport && `${passport.outdated.format('DD.MM.YYYY')}` || foreign_passport && `${foreign_passport.outdated.format('DD.MM.YYYY')}`}
                        </Body1>
                        || <ConfirmedText> Документ подтвержден </ConfirmedText>
                    }
                </AddInfoContent>}
        </AddInfo>
    )
}